import React from 'react';
import ClassroomSelect from '@/components/common/ModelSelect/ClassroomSelect';
import UnitLessonSelect from '@/components/common/ModelSelect/UnitLessonSelect';
import I18n from '@/modules/i18n';
import * as Routes from '@/modules/routes';
import useFlags from '@/hooks/useFlags';
import useGradesTableStore from './store/useGradesTableStore';

const Navigation = () => {
  const classroom = useGradesTableStore(state => state.classroom);
  const allLessons = useGradesTableStore(state => state.allLessons);
  const lesson = useGradesTableStore(state => state.lesson);
  const unit = useGradesTableStore(state => state.unit);
  const programId = useGradesTableStore(state => state.programId);
  const stafferId = useGradesTableStore(state => state.stafferId);
  const { gradingFilters } = useFlags();

  const classroomSelectUrl = Routes.teacher_score_path('select_id', {
    program_id: programId,
    ...(allLessons && { lesson_id: 'all' }),
    ...(!!lesson?.id && { lesson_id: lesson.id }),
    ...(!!unit?.id && { unit_id: unit.id }),
  });

  const lessonSelectUrl = Routes.teacher_program_scores_path(programId, {
    classroom_id: classroom.id,
    lesson_id: 'select_id',
  });

  const unitSelectUrl = Routes.teacher_program_scores_path(programId, {
    classroom_id: classroom.id,
    unit_id: 'select_id',
  });

  return (
    <div className="tw-flex tw-gap-5">
      {classroom.id && (
        <ClassroomSelect
          showOutOfTermClassrooms
          initialOption={{
            label: classroom?.name,
            value: classroom?.id,
          }}
          programId={programId}
          resourceUrl={classroomSelectUrl}
          stafferId={stafferId}
        />
      )}

      {(lesson?.id || unit?.id || allLessons) && (
        <UnitLessonSelect
          includeAllLessonsOption={gradingFilters}
          initialOption={allLessons ? {
            label: I18n.t('all_units_lessons'),
            value: 'all',
          } : {
            label: (unit || lesson).title,
            value: (unit || lesson).id,
          }}
          parentResourceUrl={unitSelectUrl}
          programId={programId}
          resourceUrl={lessonSelectUrl}
        />
      )}
    </div>
  );
};

export default Navigation;
